import { lazy } from 'react';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';

// Lazy, so the MUI lists load only when an editor opens the index, as they did inside the editor bundle.
const EditorIndex = lazy(() => import(/* webpackPrefetch: true */ 'EditorIndex'));

export function EditorIndexComponent() {
    // The lists read Angular models, such as Lesson, that the editor bundle registers.
    useLoadEditorDependencies();
    return <EditorIndex />;
}
